// 无线接入点
import React, { createRef, PureComponent } from 'react';
import { Button, notification, Form, Select, Input } from 'antd';
import { ServerPageDecoration } from './ServerPageDecoration'

const { Option } = Select;


export class AP extends PureComponent {
    constructor(props) {
      super(props);
  
      this.formRef = createRef();
  
      ['onReset', 'onSubmit', 'onFail', 'onChange'].forEach(func => this[func] = this[func].bind(this));
      
      const { device } = props;
      const { wifiSetting } = device.toJSON();

      this.state = {
        version: 0,
        encryptMode: wifiSetting.encryptMode
      }
    }
  
    onReset() {
      this.formRef.current.resetFields();
      this.setState({
        version: 0
      });
    }
  
    onSubmit(config) {
      const { device, onClose } = this.props;

      device.updateWIFISetting(config);
 
      this.setState({
        version: 0
      }, () => {
        notification.success({
            message: '配置已生效',
        });
    
        // 自动关闭
        if(onClose) {
          onClose();
        }
      });
    }
  
    onFail(errorInfo) {
      notification.error({
        message: '错误',
        description: '表单填写出错，请按照提示信息进行检查！'
      });
    }
  
    onChange(changedValues, allValues) {
      let { version } = this.state;
      version++;
  
      const nextState = {
        version
      };
  
      // 刷新UI
      if(changedValues.encryptMode) {
        nextState.encryptMode = changedValues.encryptMode;
      }
  
      this.setState(nextState);
    }
  
    render() {
      const { formRef } = this;
      const { device, border = true } = this.props;
      const { wifiSetting: value } = device.toJSON();
      const { version, encryptMode } = this.state;

      const content = (
        <Form
            ref={formRef}
            name="APConfig"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 10 }}
            initialValues={value}
            size="large"
            onFinish={this.onSubmit}
            onFinishFailed={this.onFail}
            onValuesChange={this.onChange}
        >
            <Form.Item
                label="SSID"
                name="SSID"
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="加密方式"
                name="encryptMode"
                rules={[{ required: true }]}
            >
                <Select>
                    <Option value="wpa/wpa2">WPA-PSK/WPA2-PSK</Option>
                    <Option value="none">不开启无线安全</Option>
                </Select>
            </Form.Item>
            {encryptMode !== 'none' ? (
              <Form.Item
                label="密码"
                name="password"
                rules={[{ required: true, min: 8, message: '密码最低位数为8位' }]}
              >
                  <Input />
              </Form.Item>
            ) : null}
            <Form.Item
                label="无线信道"
                name="channel"
                rules={[{ required: true }]}
            >
                <Select>
                    <Option value="0">自动（6）</Option>
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    <Option value="6">6</Option>
                    <Option value="7">7</Option>
                    <Option value="8">8</Option>
                    <Option value="9">9</Option>
                    <Option value="10">10</Option>
                    <Option value="11">11</Option>
                    <Option value="12">12</Option>
                </Select>
            </Form.Item>
            <Form.Item
                label="信号强度"
                name="strength"
                rules={[{ required: true }]}
            >
                <Select>
                    <Option value="节能">节能</Option>
                    <Option value="标准">标准</Option>
                    <Option value="穿墙">穿墙</Option>
                </Select>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 4, span: 10 }}>
                <Button type={ version ? "danger": "primary"} htmlType="submit">
                    确定
                </Button>
                <Button style={{marginLeft: 10}} htmlType="button" onClick={this.onReset}>
                    重置
                </Button>
            </Form.Item>
        </Form>
      );

      if(!border) {
        return content;
      }
  
      return (
        <ServerPageDecoration>
          {content}
        </ServerPageDecoration>);
    }
}
